import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PfepService } from '../../services/pfepService';
import { NoubaTableData, HistoryData } from '../../models/pfepModels';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pfep-history',
  templateUrl: './pfep-history.component.html',
  styleUrls: ['./pfep-history.component.scss']
})
export class PfepHistoryComponent implements OnInit {
  rackHistoryMetaData = [
    { header: 'Rack Code', field: 'rackCode' },
    { header: 'Driving Direction', field: 'drivingDirection' },
    { header: 'Coordinate X', field: 'x' },
    { header: 'Coordinate Y', field: 'y' },
    { header: 'Size Depth(X)', field: 'depth' },
    { header: 'Size Width(Y)', field: 'width' },
    { header: 'Size Height(Z)', field: 'height' },
    { header: 'Building Number', field: 'building' },
    { header: 'Shelf Count', field: 'shelfCount' },
    { header: 'Column Count', field: 'columnCount' },
    { header: 'Updated Date', field: 'timeStamp' },
    { header: 'User Name', field: 'userName' }
  ];
  rackHistoryFields = this.rackHistoryMetaData.map(c => c.field);

  noubaHistoryMetaData = [
    { header: 'Nouba Code', field: 'noubaCode' },
    { header: 'Driving Direction', field: 'drivingDirection' },
    { header: 'Coordinate X', field: 'x' },
    { header: 'Coordinate Y', field: 'y' },
    { header: 'Size Depth(X)', field: 'depth' },
    { header: 'Size Width(Y)', field: 'width' },
    { header: 'Building Number', field: 'building' },
    { header: 'Updated Date', field: 'timeStamp' },
    { header: 'User Name', field: 'userName' }
  ];
  noubaHistoryFields: any;
  displayedNoubaHistoryColumns = ['noubaCode', 'initialUpload', 'lastModified', 'changeHistory', 'lastUpdatedBy' ];
  historyDataSource;
  dataSource;
  constructor(public dialogRef: MatDialogRef<PfepHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private pfepService: PfepService, private spinner: NgxSpinnerService) { 
      this.noubaHistoryFields = this.noubaHistoryMetaData.map(c => c.field);
    }

  ngOnInit() {
    if (this.data.type === 'RackHistory') {
      this.getRackCodeHistory(this.data.rackHistoryData.rackCode);
    } else {
      this.getNoubaCodeHistory(this.data.noubaHistoryData.noubaCode);
    }
  }

  getRackCodeHistory(code) {
    this.spinner.show();
    this.pfepService.getRackHistoryData(code).subscribe(response => {
      if (response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.prepareHistoryDataSource(response);
      }
    }, error => {
      this.spinner.hide();
    });
  }

  private prepareHistoryDataSource(response: any) {
    if (response.result.length > 0) {
      let latest = response.result[0];
      const HISTORY: HistoryData = {
        code: latest.rackCode,
        initialUploadDate: response.result.at(-1).timeStamp,
        lastModifiedDate: latest.timeStamp,
        userName: latest.userName,
        history: response.result
      };
      this.historyDataSource = HISTORY;
    }
  }

  getNoubaCodeHistory(code) {
    this.pfepService.getNoubaHistoryData(code).subscribe(response => {
      if (response.status && response.status.statusCode === 200) {
        this.dataSource = new MatTableDataSource<NoubaTableData>(response.result);
        this.prepareNoubaHistoryDataSource(response);
      }
    }, error => {
    });
  }

  private prepareNoubaHistoryDataSource(response: any) {
    if (response.result.length > 0) {
      let latest = response.result[0];
      const HISTORY: HistoryData = {
        code: latest.noubaCode,
        initialUploadDate: response.result.at(-1).timeStamp,
        lastModifiedDate: latest.timeStamp,
        userName: latest.userName,
        history: response.result
      };
      this.historyDataSource = HISTORY;
    }
  }


  onNoClick(): void {
    setTimeout(function(){
    }, 1000);
    this.dialogRef.close();
  }
}
